var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.82688 10.5448H13.1731V9.2948H6.82688V10.5448ZM6.82688 12.9488H13.1731V11.6988H6.82688V12.9488ZM6.82688 15.3525H10.6731V14.1025H6.82688V15.3525ZM5.25646 17.9167C4.83549 17.9167 4.47917 17.7708 4.1875 17.4792C3.89583 17.1875 3.75 16.8312 3.75 16.4102V3.5898C3.75 3.16883 3.89583 2.81251 4.1875 2.52084C4.47917 2.22918 4.83549 2.08334 5.25646 2.08334H11.875L16.25 6.45834V16.4102C16.25 16.8312 16.1042 17.1875 15.8125 17.4792C15.5208 17.7708 15.1645 17.9167 14.7435 17.9167H5.25646ZM11.25 7.08334V3.33334H5.25646C5.19229 3.33334 5.13354 3.36008 5.08021 3.41355C5.02674 3.46688 5 3.52564 5 3.5898V16.4102C5 16.4744 5.02674 16.5331 5.08021 16.5865C5.13354 16.6399 5.19229 16.6667 5.25646 16.6667H14.7435C14.8077 16.6667 14.8665 16.6399 14.9198 16.5865C14.9733 16.5331 15 16.4744 15 16.4102V7.08334H11.25Z",
    fill: "#00231D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFile);
export default __webpack_public_path__ + "static/media/Ic_file.64549c5103eff97e848904a22bb0f481.svg";
export { ForwardRef as ReactComponent };